const { trackGtm, trackGtm4 } = require('../../../../js/functions');

module.exports = {
	init() {
		const closeError = this.root.querySelector('.related-category--close');
		const linkList = this.root.querySelectorAll('a');
		const mainTitle = this.root.querySelector('.category-title');
		const readingTime = this.root.querySelector('.related-category--reading');

		linkList.forEach(element => {
			element.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'articles',
					eventAction: 'Related category articles',
					eventLabel: element.href,
				});
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: 'V3-Related-category-articles',
					widget_title: mainTitle ? mainTitle.innerHTML : 'Title not set',
					link_text: element.innerHTML,
					link_url: element.href,
					button_type: '',
				});
				trackGtm4({
					event: 'GA4_event_c_related_category_article',
					widget_name: 'V3-Related-category-articles',
					widget_title: mainTitle ? mainTitle.innerHTML : 'Title not set',
					category_name: mainTitle ? mainTitle.innerHTML : 'Category not set',
					link_text: element.innerText,
					link_url: element.href,
					reading_time: readingTime ? readingTime.innerHTML : 'No reading time',
				});
			});
		});
		if (closeError)
			closeError.addEventListener('click', this.hideWarning.bind(this));
	},
	hideWarning() {
		const modalError = this.root.querySelector('.related-category--warning');
		modalError.style.display = 'none';
	},
};
